<template>
    <div class="module-header">
        <div class="author-sign">
            <p class="title">{{ moduleName }}</p>
            <p class="by-author">
                <el-tag type="info" size="mini">by {{ authorName }}</el-tag>
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            moduleName: String,
            authorName: String
        },
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>
<style lang="less" scoped>
    .module-header {
        overflow: hidden;
        position: fixed;
        top: 5px;
        right: 200px;
        z-index: 99;
    }
    .author-sign {
        overflow: hidden;
        border: solid 1px #ddd;
        padding: 5px;
        // box-shadow: 3px 3px 1px 0px rgba(0,0,0,0.05);
        box-shadow: 3px 3px 1px 0px rgba(255,255,255,0.5);
        margin: 3px;
        float: right;
        .title {
            float: left;
            color: #ddd;
            font-size: 14px;
            line-height: 14px;
            padding-left: 5px;
            border-left: solid 3px #409EFF;
            margin-top: 3px;
        }
        .by-author {
            float: left;
            margin-left: 10px;
            .el-tag {
                background-color: #ecf5ff;
                border: 1px solid #d9ecff;
                display: inline-block;
                height: 20px;
                padding: 0 5px;
                line-height: 19px;
                font-size: 12px;
                color: #409eff;
                border-radius: 4px;
                box-sizing: border-box;
                white-space: nowrap;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/authorSign.vue